/**
 * Inventory Hierarchy API Service
 * 
 * Handles all API calls related to inventory hierarchy
 */
import { apiService } from './api.service';

class InventoryHierarchyService {
  constructor() {
    this.baseUrl = '/inventory-hierarchy';
  }

  async getInventoryHierarchy() {
    try {
      return await apiService.get(`${this.baseUrl}/tree`);
    } catch (error) {
      console.error('Error fetching inventory hierarchy:', error);
      throw error;
    }
  }

  async getNodeDetails(nodeId) {
    try {
      return await apiService.get(`${this.baseUrl}/nodes/${nodeId}`);
    } catch (error) {
      console.error('Error fetching node details:', error);
      throw error;
    }
  }

  async getNodeStatistics(nodeId) {
    try {
      return await apiService.get(`${this.baseUrl}/nodes/${nodeId}/statistics`);
    } catch (error) {
      console.error('Error fetching node statistics:', error);
      throw error;
    }
  }

  async searchNodes(query) {
    try {
      return await apiService.get(`${this.baseUrl}/search`, { params: { query } });
    } catch (error) {
      console.error('Error searching nodes:', error);
      throw error;
    }
  }
}

export const inventoryHierarchyService = new InventoryHierarchyService(); 